import classnames from 'classnames';
import { PureComponent } from 'react';

import styles from './repeaterDivider.module.scss';

type PropsT = {
  className?: string;
  label?: string;
};

export class RepeaterDivider extends PureComponent<PropsT> {
  render() {
    const { className, label, ...otherProps } = this.props;

    const rootClass = classnames(
      {
        [styles.root]: true,
        [styles.rootHasLabel]: !!label,
      },
      className,
    );

    return (
      <div {...otherProps} className={rootClass}>
        {!!label && <div className={styles.label}>{label}</div>}
      </div>
    );
  }
}
